import { render, staticRenderFns } from "./MealTemplate.vue?vue&type=template&id=c800a3ec&scoped=true&"
import script from "./MealTemplate.vue?vue&type=script&lang=js&"
export * from "./MealTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c800a3ec",
  null
  
)

export default component.exports